import { ChartSeries, ChartSetup } from "./enrollment.chart-controller";

var Highcharts = require('highcharts/highcharts');
require('highcharts/highcharts-more')(Highcharts);


export class ChartBar {

    chart: any;
    idxMap: Map<string, number>;
    constructor() { }

    UpdateChart(chartSetup: ChartSetup, yAxisTitle: string = "Number of Participants", numberOfDecimalPoints: number = 0, dateFormat: string = '%b %Y', percentages: boolean = false): void {

        yAxisTitle = percentages ? "Percent (" + yAxisTitle + ")" : yAxisTitle;

        this.idxMap = new Map();

        chartSetup.series.forEach((s: ChartSeries, idx: number) => {
            this.idxMap.set(s.name, idx);
        });


        this.chart = Highcharts.chart('enrollment-chart', {
            chart: {
                type: 'column',
                backgroundColor: 'white',
                zoomType: 'x',
                resetZoomButton: {
                    position: {
                        align: 'right', // right by default
                        verticalAlign: 'top',
                        x: -10,
                        y: 0
                    },
                    relativeTo: 'chart'
                },
                ignoreHiddenSeries: !percentages,
            },
            credits: { enabled: false },
            title: { text: null },
            xAxis: {
                type: 'datetime',
                //max: maxDate,
                showLastLabel: true,
                labels: {
                    formatter: function () {
                        return Highcharts.dateFormat('%b \'%y', this.value);
                    }
                }
            },
            yAxis: {
                //max: maxEnrollment,
                title: {
                    text: yAxisTitle
                },
                labels: {
                    formatter: function () {
                        return Highcharts.numberFormat(this.value, 0, '', ',') + (percentages ? "%" : "");
                    }
                },
                stackLabels: {
                    enabled: true,
                    style: {
                        textOutline: 'none',
                        color: 'black',
                        fontWeight: 'bold'
                    },
                    formatter: function () {
                        if (percentages) {
                            return '';
                        }
                        return Highcharts.numberFormat(this.total, numberOfDecimalPoints);
                    }
                }
            },
            plotOptions: {
                series: {
                    stacking: percentages ? 'percent':  'normal',
                    states: {
                        inactive: {
                            enabled: false,
                        },
                    },

                    events: {
                        legendItemClick: (e) => {
                            if (!percentages) { return }

                            let newIdxMap = new Map<any, number>();

                            this.chart.series.forEach((s, idx, arr) => {
                                let showIndex = arr.length - this.idxMap.get(s.name);

                                if ((!s.visible && s.name != e.target.name) || (s.visible && s.name == e.target.name)) {
                                    showIndex = 0;
                                }

                                newIdxMap.set(s, showIndex);
                                // s.update({ index: showIndex });

                            });

                            newIdxMap.forEach((showIndex, s) => {
                                s.update({
                                    index: showIndex
                                });
                            });
                        }
                    }
                },
                
            },
            tooltip: {
                xDateFormat: dateFormat,
                shared: false,
                formatter: function () {

                    let numbers: string = Highcharts.numberFormat(this.y, numberOfDecimalPoints);
                    let totals: string = Highcharts.numberFormat(this.total, numberOfDecimalPoints);

                    if (percentages) {
                        let percent: number = (this.y / this.total) * 100.00;
                        numbers = Highcharts.numberFormat(percent, numberOfDecimalPoints) + "% ( " + numbers + " / " + totals + " )";
                    }

                    let value: string = "<span class='font-size10'>" + Highcharts.dateFormat(dateFormat, this.x) + "</span><br>";
                    value += "<span style='color:" + this.color + "'>●</span> " + this.series.name + ": <b>" + numbers + "</b>";
                    return value;
                }
            },
            legend: {
                enabled: chartSetup.showLegend
            },
            series: chartSetup.series
        });
    }
}